export default __webpack_public_path__ + "static/media/default.5cdad974.png";